common.View.create('shop::website.modules.shopProducts.index.filters.Remove', {

    showRemoveFilter(result)
    {
        // Show remove filters?
        if( !$.isEmptyObject(result) ) {
            // this.element.find('.removeFilters')
            $('.shop\\:\\:website-modules-shopProducts-index-filters-Remove')
                .removeClass('hidden').addClass('text-black');
        }
        else {
            // this.element.find('.removeFilters')
            $('.shop\\:\\:website-modules-shopProducts-index-filters-Remove')
                .addClass('hidden').removeClass('text-black');
        }

        return result;
    },

});
